import './partners.scss';
import './img/c-partners-1.png';
import './img/c-partners-2.png';
import './img/c-partners-3.png';
import './img/c-partners-4.png';
import './img/c-partners-5.png';
import './img/c-partners-6.png';
